
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import WhySellToUsSection from './components/WhySellToUsSection';
import HowItWorksSection from './components/HowItWorksSection';
import ComprehensiveGuideSection from './components/ComprehensiveGuideSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function SellDistressedPropertyPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Sell Distressed Property El Paso | We Buy Damaged Houses As-Is"
        description="Sell your distressed property fast for cash in El Paso. We buy fire-damaged, water-damaged, and neglected houses as-is. No repairs needed, fair cash offers."
        keywords="sell distressed property El Paso, sell damaged house, fire damaged house buyers, water damaged property, sell house as-is El Paso"
        canonical="/sell-distressed-property"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Distressed Property Buying Service",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <WhySellToUsSection />
      <HowItWorksSection />
      <ComprehensiveGuideSection />
      <TestimonialsSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}
